export default "__VITE_ASSET__C9UZ0qGI__"